import {AfterViewInit, Component, Input, OnInit, SimpleChanges} from '@angular/core';
import G2 from '@antv/g2/build/g2';

@Component({
  selector: 'lib-yunzai-g2',
  template: `
    <div id='cl'></div>
  `,
  styles: []
})
export class YunzaiG2Component implements OnInit , AfterViewInit {

  @Input()
  id = 'simpleId';

  @Input()
  data: Array<any> = [];

  constructor() { }

  ngOnInit() {
  }

  chartData() {
    document.getElementById('cl').innerHTML = '';
    console.log(this.data);
    // Step 1: 创建 Chart 对象
    const chart = new G2.Chart({
      container: 'cl', // 指定图表容器 ID
      width: 600, // 指定图表宽度
      height: 300, // 指定图表高度
    });
    // Step 2: 载入数据源
    chart.source(this.data);
    // Step 3：创建图形语法，绘制柱状图，由 genre 和 sold 两个属性决定图形位置，genre 映射至 x 轴，sold 映射至 y 轴
    chart
      .interval()
      .position('genre*sold')
      .color('genre');
    // Step 4: 渲染图表
    chart.render();
  }

  ngAfterViewInit(): void {

  }


  // tslint:disable-next-line:use-lifecycle-interface
  async ngOnChanges(changes: SimpleChanges) {
    if (changes.data.currentValue && changes.data.currentValue.length > 0) {
      this.chartData();
    }
  }
}
